"use client";

import { useQuery } from "@tanstack/react-query";
import { backendClient } from "@/lib/backend-api";

const POLLING_INTERVAL_MS = 120_000;
export const GETTING_STARTED_WIDGET_VISIBLE_MS = 24 * 60 * 60 * 1000;
export const gettingStartedQueryKey = ["getting-started"] as const;

export const shouldShowGettingStartedWidget = (
  completedAt: string | null | undefined,
) => {
  if (!completedAt) {
    return true;
  }

  return (
    Date.now() - new Date(completedAt).getTime() <
    GETTING_STARTED_WIDGET_VISIBLE_MS
  );
};

export const useGettingStartedProgress = () =>
  useQuery({
    queryKey: gettingStartedQueryKey,
    queryFn: () => backendClient.shop.getGettingStartedProgress(),
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchInterval: (query) => {
      if (query.state.status !== "success") return false;
      return shouldShowGettingStartedWidget(query.state.data?.completedAt)
        ? POLLING_INTERVAL_MS
        : false;
    },
  });
